
















































import axios from 'axios';
import ActionCellRenderer from '@/components/ag-grid/ActionCellRenderer.vue'
import ProjectForm from '@/components/settings/ProjectForm.vue'
import Vue from 'vue';
import _ from 'lodash';
import format from 'date-fns/format'

export default Vue.extend({
    components: {
        ProjectForm
    },
    data() {
        return {
            isSubmitting: false,
            isShowConfirmRemoveModal: false,
            isShowForm: false,
            projects: [] as any[],
            gridOptions: {
                columnDefs: [] as any[],
                rowHeight: 35
            } as any,
            selectedProject: null as any,
            columnDefs: [] as any[],
            editingProject: null as any,
            gridApi: null as any,
        }
    },
    async mounted() {
        await this.getProjects();
        await this.getClients();

        this.columnDefs = [
            {
                headerName: 'Actions',
                editable: false,
                colId: 'params',
                field: 'value',
                pinned: 'left',
                cellRendererFramework: ActionCellRenderer,
                cellRendererParams: {
                    remove: this.confirmRemoveEntry,
                    update: this.update,
                    edit: this.editProject
                },
                width: 80
            },
            {
                pinned: 'left',
                headerName: 'Name',
                field: 'name',
                sortable: true,
                filter: true,
                editable: true
            },
            {
                headerName: 'Description',
                field: 'description',
                sortable: true,
                filter: true,
                editable: true
            },
            {
                headerName: 'Client',
                field: 'client_id',
                sortable: true,
                filter: true,
                valueGetter: (params: any) => {
                    const client = this.$store.state.clients.find((client: any) => {
                        return client.id === params.data.client_id;
                    });
                    
                    return client ? client.name : '';
                }
            },
            {
                headerName: 'Purchase Order',
                field: 'purchase_order',
                sortable: true,
                filter: true,
                editable: true
            },
            {
                headerName: 'Purchase Order Date',
                field: 'purchase_order_date',
                sortable: true,
                filter: true,
                editable: true,
                valueGetter: (params: any) => {
                    if (!params.data.purchase_order_date) {
                        return '';
                    }

                    return format(new Date(params.data.purchase_order_date), 'MMM DD, YYYY');
                }
            },
            {
                headerName: 'Quote',
                field: 'quote',
                sortable: true,
                filter: true
            },
            {
                headerName: 'Quote Date',
                field: 'quote_date',
                sortable: true,
                filter: true,
                valueGetter: (params: any) => {
                    if (!params.data.quote_date) {
                        return '';
                    }

                    return format(new Date(params.data.quote_date), 'MMM DD, YYYY');
                }
            },
        ];

        if (this.$store.getters.isAdmin) {
            this.columnDefs.push({
                headerName: 'Quote Hours',
                field: 'quote_hours',
                sortable: true,
                filter: true,
                editable: true
            });

            this.columnDefs.push({
                headerName: 'Quote Rate',
                field: 'quote_rate',
                sortable: true,
                filter: true,
                editable: true,
                valueFormatter: (params: any) => {
                    if (params.value) {
                        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(params.value);
                    }
                }
            });

            this.columnDefs.push({
                headerName: 'Quote Amount',
                field: 'quote_amount',
                sortable: true,
                filter: true,
                editable: true,
                valueFormatter: (params: any) => {
                    if (params.value) {
                        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(params.value);
                    }
                }
            });
        }
    },
    methods: {
        resetWorkType() {
            // this.worktype = {
            //     id: 0,
            //     name: '',
            //     description: ''
            // };
        },
        closeForm() {
            this.isShowForm = false
            this.selectedProject = null;
            this.editingProject = null;
        },
        confirmRemoveEntry(data: any) {
            this.selectedProject = data;
            this.isShowConfirmRemoveModal = true;
        },
        async update() {
            console.log("update")
        },
        async remove() {
            if (this.isSubmitting) { return; }

            this.isSubmitting = true;

            try {
                await axios.delete(`/projects/${this.selectedProject.id}`);
                const index = this.projects.findIndex((project: any) => {
                    return project.id === this.selectedProject.id;
                });
                
                if (index > -1) {
                    this.projects.splice(index, 1);
                }

                this.isShowConfirmRemoveModal = false;
                this.selectedProject = null;
            } catch (e) {
                console.error(e);
            } finally {
                this.isSubmitting = false;
            }
        },
        async onCellChanged(params: any) {
            try {
                await axios.put(`/projects/${params.data.id}`, params.data);
                this.projects = _.orderBy(this.projects, ['name'], ['asc']);
            } catch (e) {
                console.error(e);
            }
        },
        onGridReady(params: any) {
            params.api.sizeColumnsToFit(1);
            this.gridApi = params.api;
        },
        onRowChanged(params: any) {
            console.log(params)
        
        },
        async getClients() {
            try {
                const result = await axios.get('/clients');
                this.$store.dispatch('SET_CLIENTS', result.data);
            } catch (e) {
                console.error(e);
            }
        },
        async getProjects() {
            try {
                const result = await axios.get(`/projects`);
                this.projects = _.orderBy(result.data, ['name'], ['asc']);
            } catch (e) {
                console.error(e);
            }
        },
        editProject(project: any) {
            this.editingProject = project;
            this.isShowForm = true;
        },
        async save(project: any) {
            if (this.isSubmitting) { return; }

            this.isSubmitting = true;

            try {
                if (project.id) {
                    const index = this.projects.findIndex((p: any) => {
                        return p.id === project.id;
                    });

                    if (index > -1) {
                        this.projects.splice(index, 1, project);
                        this.projects = _.orderBy(this.projects, ['name'], ['asc']);
                    }
                } else {
                    this.projects = _.orderBy([...this.projects, project], ['name'], ['asc']);
                }
            } catch (e) {
                console.error(e);
            } finally {
                this.isShowForm = false;
                this.isSubmitting = false;
            }
        }
    }
});
